import React, {useState} from 'react';
import Button from '@mui/material/Button';
import {supabase} from '../../supabase';
import {Alert, Box, CircularProgress} from "@mui/material";
import Title from "../navigation/Title";

interface SyncResult {
    "loaded": number,
    "deleted": number,
    "updated": number,
    "inserted": number,
    "error": number
    "errors"?: string[]
}

export default () => {
    const [errors, setErrors] = useState<string[]>([]);
    const [result, setResult] = useState<SyncResult | null>(null)
    const [loading, setLoading] = useState(false)
    const handleFetch = async (functionName: string) => {
        try {
            setLoading(true)
            setResult(null)
            setErrors([])
            const {data, error: fetchError} = await supabase.functions.invoke(functionName);

            if (fetchError) {
                setErrors([`Error fetching ${functionName}: ${fetchError.message}`]);
            } else if (!data) {
                setErrors([`No data returned from ${functionName}`]);
            } else {
                setResult(JSON.parse(data))
                if (JSON.parse(data).errors && JSON.parse(data).errors.length > 0) {
                    setErrors(JSON.parse(data).errors)
                }
            }
        } catch (err:any) {
            setErrors([`Unexpected error: ${err?.message}`]);
        }
        setLoading(false)
    };

    return <>
        <Title title={"Sinhronizacija podatkov"}></Title>
        <Box sx={{
            "display": "grid",
            mt: "1em",
            gridGap: "1em",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            "& > button": {minHeight: "5em"}
        }}>
            <Button
                disabled={loading}
                variant="contained"
                onClick={() => handleFetch('fetch-active-products')}>
                Produkti
            </Button>
            <Button
                disabled={loading}
                variant="contained"
                onClick={() => handleFetch('fetch-active-workers')}>
               Delavci
            </Button>
            <Button
                disabled={loading}
                variant="contained"
                onClick={() => handleFetch('fetch-buyers')}>
               Kupci
            </Button>
            <Button
                disabled={loading}
                variant="contained"
                onClick={() => handleFetch('fetch-work-orders')}>
                Delovni nalogi
            </Button>
            <Button
                disabled={loading}
                variant="contained"
                onClick={() => handleFetch('post-working-hours')}>
                Registracije
            </Button>
        </Box>
        {loading && <Box sx={{mt:"1em"}}>
            <CircularProgress/>
        </Box>}
        {errors && errors.map((error) => <Box sx={{mt:"1em"}}>
                    <Alert severity={"error"}>
                {error}
            </Alert>
                </Box>)}
        {result && <Box sx={{mt: "1em"}}>
            <ul>
                <li>loaded: {result.loaded}</li>
                <li>inserted: {result.inserted}</li>
                <li>updated: {result.updated}</li>
                <li>deleted: {result.deleted}</li>
                <li>error: {result.error}</li>
            </ul>
        </Box>}
    </>
};

